import gsap from 'gsap';

export const uyTransitionIn = () => {
    return new Promise((resolve) => {
        const el    = document.querySelector('#uy-transition');
        const left  = el.querySelector('#uy-left');
        const right = el.querySelector('#uy-right');
        const logo  = el.querySelector('#uy-logo');

        gsap.set(el,    { display: 'block' });
        gsap.set(left,  { xPercent: -100, backgroundColor: '#0a0a0a' });
        gsap.set(right, { xPercent: 100,  backgroundColor: '#0a0a0a' });
        gsap.set(logo,  { opacity: 0 });

        const tl = gsap.timeline({ onComplete: resolve });

        tl
            .to(left,  { xPercent: 0, duration: 0.6, ease: 'power3.inOut' }, 0)
            .to(right, { xPercent: 0, duration: 0.6, ease: 'power3.inOut' }, 0)
            .to(logo,  { opacity: 1, duration: 0.3, ease: 'power2.out' }, '-=0.1')
            .to([left, right], { backgroundColor: '#facc15', duration: 0.5, ease: 'power2.inOut' }, '+=0.2')
            .to(logo.querySelector('svg'), { stroke: '#0a0a0a', duration: 0.3 }, '-=0.4');
    });
};

export const uyTransitionOut = () => {
    return new Promise((resolve) => {
        const el     = document.querySelector('#uy-transition');
        const left   = el.querySelector('#uy-left');
        const right  = el.querySelector('#uy-right');
        const logo   = el.querySelector('#uy-logo');
        const loader = document.querySelector('#transition-loader');

        if (loader) gsap.set(loader, { display: 'none', autoAlpha: 0 });

        // FIX 2 : suppression du double resolve — onComplete: resolve retiré de la timeline,
        // un seul resolve dans le .call() final
        const tl = gsap.timeline();

        tl
            .to(logo,  { opacity: 0, duration: 0.2 })
            .to(left,  { yPercent: -100, duration: 0.6, ease: 'power3.inOut' }, '+=0.1')
            .to(right, { yPercent: 100,  duration: 0.6, ease: 'power3.inOut' }, '<')
            .call(() => {
                gsap.set(el,    { display: 'none' });
                gsap.set(left,  { xPercent: -100, yPercent: 0, backgroundColor: '#0a0a0a' });
                gsap.set(right, { xPercent: 100,  yPercent: 0, backgroundColor: '#0a0a0a' });
                gsap.set(logo,  { opacity: 0 });
                gsap.set(logo.querySelector('svg'), { stroke: '#facc15' });
                resolve();
            });
    });
};